import { Link } from "react-router-dom";
import Banner from "../components/Banner.js";
import { FiMail, FiMessageCircle } from "react-icons/fi"
export default function Contact() {

  return (
    <>
     <Banner />
   <div className="max-w-7xl mx-auto mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 px-4">
  {/* Contact Card 1 */}
  <div className="relative w-full bg-[#1A0B2E] border border-[#6A2FC1] p-8 rounded-md hover:theme-background">
    {/* Icons in Top-Right */}
    <div className="text-white">
      <FiMail className="w-9 h-9 bg-[#3c1a69] p-1 rounded-md" />

    </div>

    <div className="flex flex-col gap-2 py-6 text-white">
      <h4 className="text-xl font-bold">Chat to discuss your project</h4>
      <p className="text-justify text-[#864DD9] text-lg">Speak to me friendly.</p>
    </div>
    <Link
      to="mailto:enginuity.system@gmail.com"
      className="btn-primary"
    >
      enginuity.system@gmail.com
    </Link>
  </div>

  {/* Contact Card 2 */}
  <div className="w-full bg-[#1A0B2E] border border-[#6A2FC1] p-8 rounded-md hover:theme-background">
    {/* Icons in Top-Right */}
    <div className=" text-white">
      
      <FiMessageCircle className="w-9 h-9 bg-[#3c1a69] p-1 rounded-md" />
    </div>

    <div className="flex flex-col gap-2 py-6 text-white">
            <h4 className="text-xl font-bold">Call me or what’s to discuss about training program</h4>
      <p className="text-justify text-[#864DD9] text-lg">Fri-Sat from 9am to 11pm.</p>
    </div>
    <Link
      to="https://wa.me/8801846895923"
      target="_blank"
      rel="noopener noreferrer"
      className="btn-outline">
      +880-1846-895923
    </Link>
  </div>
</div>

    </>
    
  )
}
